import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Cookie, Lock, BarChart3 } from "lucide-react";
import { Link } from "react-router-dom";

interface CookieConsentModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export function CookieConsentModal({
  isOpen,
  onAccept,
  onDecline,
}: CookieConsentModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="light font-archivo max-w-[95vw] sm:max-w-[520px] gap-0 overflow-hidden rounded-[3px] border border-[#1E1B4B]/[0.12] bg-white p-0"
      >
        <div className="flex items-start gap-[11px] border-b border-[#1E1B4B]/[0.12] px-6 py-[22px]">
          <Cookie
            className="mt-0.5 h-[22px] w-[22px] shrink-0 text-[#5A31D8]"
            strokeWidth={1.6}
          />
          <div className="flex min-w-0 flex-1 flex-col gap-[5px]">
            <span className="font-archivo text-lg font-bold leading-[1.3] text-[#1E1B4B]">
              Cookies on PayStreem
            </span>
            <span className="font-archivo text-[13px] leading-[1.55] text-[#6E6B8A]">
              We use essential and analytics cookies.{" "}
              <Link to="/privacy" className="font-medium text-[#5A31D8]">
                Privacy Policy
              </Link>
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-[10px] px-6 py-5">
          <div className="flex items-start gap-[11px] rounded-[3px] border border-[#1E1B4B]/[0.12] p-[14px_15px]">
            <Lock
              className="mt-0.5 h-[18px] w-[18px] shrink-0 text-[#5A31D8]"
              strokeWidth={1.5}
            />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <span className="font-archivo text-sm font-semibold leading-[1.3] text-[#1E1B4B]">
                Essential
              </span>
              <span className="font-archivo text-[13px] leading-[1.5] text-[#6E6B8A]">
                Keeps you signed in and your player settings working. Always
                on.
              </span>
            </div>
            <span className="mt-0.5 flex h-[22px] w-[38px] shrink-0 items-center justify-end rounded-full bg-[#5A31D8] px-[3px]">
              <span className="h-4 w-4 rounded-full bg-white" />
            </span>
          </div>

          <div className="flex items-start gap-[11px] rounded-[3px] border border-[#1E1B4B]/[0.12] p-[14px_15px]">
            <BarChart3
              className="mt-0.5 h-[18px] w-[18px] shrink-0 text-[#6E6B8A]"
              strokeWidth={1.7}
            />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <span className="font-archivo text-sm font-semibold leading-[1.3] text-[#1E1B4B]">
                Analytics
              </span>
              <span className="font-archivo text-[13px] leading-[1.5] text-[#6E6B8A]">
                Anonymous counts of plays and page visits, used to tune what
                we recommend.
              </span>
            </div>
            <span className="mt-0.5 flex h-[22px] w-[38px] shrink-0 items-center rounded-full border border-[#1E1B4B]/[0.12] bg-[#EFEFF7] px-[3px]">
              <span className="h-4 w-4 rounded-full border border-[#1E1B4B]/[0.16] bg-white" />
            </span>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-[10px] border-t border-[#1E1B4B]/[0.12] px-6 py-4 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onDecline}
            className="flex w-full items-center justify-center rounded-[2px] border border-[#1E1B4B]/[0.22] px-[18px] py-[14px] font-archivo text-sm font-semibold text-[#4A4770] hover:bg-[#F7F7FB] sm:w-auto"
          >
            Essential Only
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="flex w-full items-center justify-center rounded-[2px] bg-[#5A31D8] px-[22px] py-[14px] font-archivo text-sm font-semibold text-white hover:bg-[#4526A8] sm:w-auto"
          >
            Accept All
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
